import { IUserLog } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DEFAULTGAP } from "../../globals"
import { toggleLoading } from "../../redux/reducers/loadingBar.slice"
import { IUsersLogsState, usersLogsStateLoadFromApi } from '../../redux/reducers/usersLogs.slice'
import { RootState } from "../../redux/store"
import { HeaderComponent } from "../common/header"
// import { TableComponentSetCurrPageProps } from "../common/table/common"
import { LogsGetWhereComponent } from "./logsGetWhere"
import { UserLogsTableComponent } from "./logsGrid"
import { TableComponentSetCurrPageProps } from "fwork.react.apptemplate"

export const UsersLogsComponent = () => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const usersLogsState: IUsersLogsState = useSelector((state: RootState) => state.usersLogsState)

  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [where, setWhere] = useState<FilterQuery<IUserLog> | undefined>()

  const loadLogs = async () => {
    dispatch(toggleLoading())

    const response = await dispatch(usersLogsStateLoadFromApi({
      where: where,
      onFinally: async () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.apiGetResult?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    boxSizing: 'border-box',
    paddingBottom: DEFAULTGAP
  }}>
    <HeaderComponent
      props={{
        style: {
          paddingInline: DEFAULTGAP
        }
      }}
      title='Logs'
      onRefreshClick={loadLogs}
    />
    <LogsGetWhereComponent
      onChange={setWhere}
      onSearchClick={loadLogs}
    />
    <UserLogsTableComponent
      setCurrPageRef={tableComponentSetCurrPageRef}
      logs={usersLogsState.payload} />
  </div>
}